export default "__VITE_ASSET__DhA9XfQK__"